import * as React from 'react'

export interface IHoverFocusState {
  isHovered: boolean
  isFocused: boolean
}

interface IProps extends React.HTMLAttributes<any> {
  children: (state: IHoverFocusState) => React.ReactNode
}

class HoverFocusObserver extends React.Component<IProps, IHoverFocusState> {
  constructor(props: IProps) {
    super(props)

    this.state = { isHovered: false, isFocused: false }
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  public render() {
    const { children, ...restProps } = this.props
    return (
      <div
        {...restProps}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      >
        {children(this.state)}
      </div>
    )
  }

  private onMouseEnter() {
    this.setState({ isHovered: true })
  }

  private onMouseLeave() {
    this.setState({ isHovered: false })
  }

  private onFocus() {
    this.setState({ isFocused: true })
  }

  private onBlur() {
    this.setState({ isFocused: false })
  }
}

export default HoverFocusObserver
